import {t} from '@lingui/core/macro';

import {getHttpMonitorsFiltersLog} from 'features/http/lib/httpFilters';
import {isTranslate} from 'shared/lib/lang';

export const setupDefaultDateFilter = (searchParams: URLSearchParams) => {
    const filters = getHttpMonitorsFiltersLog(searchParams);

    if (!filters['checkedAt[after]'] || !filters['checkedAt[before]']) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Локальное время

        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1); // Локальное время

        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set('checkedAt[after]', today.toISOString());
        newSearchParams.set('checkedAt[before]', tomorrow.toISOString());
        newSearchParams.set('page', '1');
        window.history.replaceState({}, '', `${window.location.pathname}?${newSearchParams}`);

        return {
            ...filters,
            'checkedAt[after]': today.toISOString(),
            'checkedAt[before]': tomorrow.toISOString(),
        };
    }

    return filters;
};

export const formatDateRange = (filters: any) => {
    const after = filters['checkedAt[after]'];
    const before = filters['checkedAt[before]'];

    if (!after || !before) return '';

    const startDate = new Date(after);
    const endDate = new Date(before);

    const formatDateTime = (date: Date) => {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        if (isTranslate()) {
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        }

        return `${day}.${month}.${year}, ${hours}:${minutes}`;
    };

    return `${t`Показаны записи за период`}: ${formatDateTime(startDate)} — ${formatDateTime(endDate)}`;
};